import axios from '../../../utils/request';

function GET_VERIFY() {
    return axios.get("/admin/common/verify", {
        params: {
            time: Math.random() * 10,
            height: 32,
            width: 150,
            font_size: 18
        },
        responseType: "arraybuffer",
    })
}
function LOGIN(params) {
    return  axios.post("admin/Common/login", params  )
}
function GET_MENU() {
    return  axios.get("/admin/AAdminMenu/menuList" )
}
function LOGOUT() {
    return  axios.post("admin/Common/logout" )
}
export default {
    GET_VERIFY,
    LOGIN,
    GET_MENU,
    LOGOUT
};